import { SET_TEAM } from '../actions/team.actions';
const initalState = {
  team: null,
  subscription: null,
  loaded: false,
  error: null
};
export default (state = initalState, action) => {
  switch (action.type) {
    case SET_TEAM:
      return {
        ...state,
        loaded: true,
        team: action.payload.team || state.team,
        subscription: action.payload.subscription || state.subscription,
        error: action.payload.error
      };
    default:
      return state;
  }
};